import React from 'react';
import { List } from './List/List';

export const Dashboards: React.FC = () => <List />;
